import { Immutable } from "immer";
import React from "react";
import { ChatLink } from "tsi-common-react/src/components/ChatLink/index";
import { WebPageURL } from "tsi-common-react/src/models/nominals";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import styles from "./index.module.scss";

export const BasketSummaryHelp = (
    props: Immutable<{ children: React.ReactNode }>,
): React.JSX.Element => {
    return <div className={styles.basketSummaryHelp}>{props.children}</div>;
};

export const BasketSummaryHelpChatLink = (
    props: Immutable<{ className?: string; chatOfflineLink: WebPageURL }>,
): React.ReactNode => {
    return (
        <ChatLink
            className={concatClassNames([
                styles.basketSummaryHelpLink,
                props.className,
            ])}
            chatOfflineLink={props.chatOfflineLink}
        />
    );
};
